import {
  Archive16Regular,
  Delete16Regular,
  Pin20Regular,
  PinOff16Regular,
  Rename16Regular,
  ShareIos20Regular,
} from '@/components/Icon'

export const THREAD_MENU_ACTION = {
  SHARE: 'share',
  RENAME: 'rename',
  PIN_TO_BOARD: 'pinToBoard',
  REMOVE_FROM_BOARD: 'removeFromBoard',
  ARCHIVE: 'archive',
  DELETE: 'delete',
}

const SHARE = { id: THREAD_MENU_ACTION.SHARE, label: 'Share', Icon: ShareIos20Regular }
const RENAME = { id: THREAD_MENU_ACTION.RENAME, label: 'Rename', Icon: Rename16Regular }
const PIN_TO_BOARD = { id: THREAD_MENU_ACTION.PIN_TO_BOARD, label: 'Pin', Icon: Pin20Regular }
const UNPIN = {
  id: THREAD_MENU_ACTION.REMOVE_FROM_BOARD,
  label: 'Unpin',
  Icon: PinOff16Regular,
  showDividerBefore: true,
}
const REMOVE_FROM_BOARD = {
  id: THREAD_MENU_ACTION.REMOVE_FROM_BOARD,
  label: 'Remove from board',
  Icon: PinOff16Regular,
  showDividerBefore: true,
}
const ARCHIVE = { id: THREAD_MENU_ACTION.ARCHIVE, label: 'Archive', Icon: Archive16Regular }
const DELETE = { id: THREAD_MENU_ACTION.DELETE, label: 'Delete', Icon: Delete16Regular }

export function getThreadMenuItems(surface = 'threads') {
  const pinRow =
    surface === 'boards' ? REMOVE_FROM_BOARD : surface === 'pinned' ? UNPIN : PIN_TO_BOARD
  return [SHARE, RENAME, pinRow, ARCHIVE, DELETE]
}
